import styles from "./index.module.scss"
import { Typography } from "@stardust-ds/react"
import { useState } from "react"
export default function RcmpAccordionSubItem(props) {
  const { data, fnSetSubitem, nCurrentId, aPropsToMap } = props

  const [nSubitemActive, fnSetNSubitemActive] = useState(-1)

  function fnHandleActiveContainer(id, index) {
    if (nSubitemActive === index) {
      fnSetSubitem(-1)
      return fnSetNSubitemActive(-1)
    }
    fnSetNSubitemActive(index)
    fnSetSubitem(id)
  }
  
  return (
    <>
      {data?.map((d, i) => {
        if (String(d?.id) === nCurrentId) return
          return (
            <div
              key={i}
              className={
                nSubitemActive === i
                  ? `${styles.container} ${styles.active}`
                  : `${styles.container}`
              }
              onClick={() =>
                fnHandleActiveContainer(
                  !aPropsToMap ? d.id : d[aPropsToMap[1]],
                  i
                )
              }
            >
              <Typography
                type={nSubitemActive === i ? "l4" : "p3"}
                color="#415364"
              >
                {!aPropsToMap ? d.name : d[aPropsToMap[0]]}
              </Typography>
            </div>
          )
      })}
    </>
  )
}
